import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { useTranslation } from "react-i18next";
import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/back1-removebg-preview.png";
import img4 from "../../assets/main/back2-removebg-preview.png";
import img5 from "../../assets/main/back3.jpg";

const BannerBottom = () => {
  const { t } = useTranslation();
  return (
    <section className="flat-about">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="about-title-box">
              <h4 className="subtitle-about">About me</h4>
              <h2 className="section-45px-montserrat">
                Why hire me for your Next project?
              </h2>
            </div>
            <div className="group-post-about wow fadeInLeft">
              <div className="post-big">
                <img src={img1} alt="images" />
              </div>
              <div className="post-sm">
                <img src={img4} alt="images" />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="content-right wow fadeInUp">
              <h3 className="section-22px-montserrat font-weight-600 line-height-35 margin-bottom-10">
                I craft beautifully useful{" "}
                <span className="text-pri mx-1">marketin and digital </span>
                products that grow.
              </h3>
              <p className="section-17px-regular margin-bottom-30">
                Etiam efficitur, metus in cursus imperdiet, neque nisl porta
                erat, nec volutpat felis lacus a tellus. Nunc tristique nulla
                nisi, a viverra dui auctor vitae. Vestibulum mollis commodo leo
                in hendrerit. Nam convallis ac lacus luctus vestibulum. Donec
                cursus tellus id neque convallis blandit.
              </p>
              <div className="icon-content-box">
                <span className="icon icon-Group-2921 font-size-40">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                </span>
                <h3 className="section-16px-regular-montserrat font-weight-600">
                  100% Work Progress.
                </h3>
              </div>
              <div className="icon-content-box">
                <span className="icon font-size-40 icon-winking1">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span>
                <h3 className="section-16px-regular-montserrat font-weight-600">
                  100% Satisfied Clients
                </h3>
              </div>
              <div className="about-years">
                <span>08</span>
                <div className="content section-20px-montserrat">
                  YEARS
                  <br />
                  EXPERIENCES
                </div>
              </div>
              <a
                href="services.html"
                className="button-footer arrow-btn btn-st style-3 margin-top-48"
              >
                View All Projects
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerBottom;
